import { render } from "./FarmerDisplay.vue?vue&type=template&id=bbc0bd54&scoped=true&ts=true"
import script from "./FarmerDisplay.vue?vue&type=script&lang=ts"
export * from "./FarmerDisplay.vue?vue&type=script&lang=ts"

import "./FarmerDisplay.vue?vue&type=style&index=0&id=bbc0bd54&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc0bd54"]])

export default __exports__